import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { BqResponse, EmptyObj } from '~/api/def/endpoints/types';
import { documentEndpoint } from '~/api/def/endpoints/document/documentEndpoint';

const endpointFundDocumentExtractedFieldExec =
  getExecEndpoint<FundDocumentExtractedFieldEndpointDef>(documentEndpoint);

export const endpointFundDocumentExtractedFieldGET = async (docId: string) => {
  return await endpointFundDocumentExtractedFieldExec<'GET'>({
    method: 'GET',
    urlExtra: `/${docId}/extracted-field`,
  });
};

export const endpointFundDocumentExtractedFieldDELETE = async (
  docId: string,
  fieldId: string,
) => {
  return await endpointFundDocumentExtractedFieldExec<'DELETE'>({
    method: 'DELETE',
    urlExtra: `/${docId}/extracted-field/${fieldId}`,
  });
};

export const endpointFundDocumentExtractedFieldEDIT = async (
  docId: string,
  fieldId: string,
  payload: EditExtractedFieldPayload,
) => {
  return await endpointFundDocumentExtractedFieldExec<'PUT'>({
    method: 'PUT',
    urlExtra: `/${docId}/extracted-field/${fieldId}`,
    payload: payload,
  });
};

interface FundDocumentExtractedFieldEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    GET: {
      response: GetFundDocumentExtractedFieldResponse;
    };
    DELETE: {
      response: DeleteExtractedFieldResponse;
    };
    PUT: {
      response: EditExtractedFieldResponse;
      payload: EditExtractedFieldPayload;
    };
  };
}

type DeleteExtractedFieldResponse = BqResponse<{
  data: object;
}>;

type EditExtractedFieldResponse = BqResponse<{
  data: object;
}>;

type GetFundDocumentExtractedFieldResponse = BqResponse<{
  data: GetDocumentExtractedFieldDataResponse[];
}>;

export type EditExtractedFieldPayload = {
  updatedValue: string;
};

type GetDocumentExtractedFieldDataResponse = {
  id: string;
  name: string;
  value: string;
  startXCoordinate: number;
  endXCoordinate: number;
  startYCoordinate: number;
  endYCoordinate: number;
  startPageNo: number;
  endPageNo: number;
};

const endpointRunFundDocumentExtractionExec =
  getExecEndpoint<FundDocumentExtractionEndpointDef>(documentEndpoint);

export const endpointRunFundDocumentExtractionPOST = async (docId: string) => {
  return await endpointRunFundDocumentExtractionExec<'POST'>({
    method: 'POST',
    urlExtra: `/${docId}/field-extraction`,
  });
};

interface FundDocumentExtractionEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    POST: {
      response: PostFundDocumentExtractionResponse;
    };
  };
}

type PostFundDocumentExtractionResponse = BqResponse<{ data: EmptyObj }>;

const endpointFundDocumentDeleteExec =
  getExecEndpoint<FundDocumentEndpointDef>(documentEndpoint);

export const endpointFundDocumentDELETE = async (docId: string) => {
  return await endpointFundDocumentDeleteExec<'DELETE'>({
    method: 'DELETE',
    urlExtra: `/${docId}`,
  });
};

interface FundDocumentEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    DELETE: {
      response: PostFundDocumentExtractionResponse;
    };
  };
}
